<mat-form-field class="w-full">
  <mat-label>{{ label() }}</mat-label>
  <mat-select
    [(value)]="value"
    (selectionChange)="onSelectionChange($event.value)"
    (openedChange)="onOpenedChange($event)"
    [disabled]="disabled"
  >
    <div
      class="search-input-container w-full z-10 pt-2 pb-2 px-2 sticky top-0"
    >
      <div
        class="search-input outline outline-1 flex flex-row w-full justify-start items-center rounded-sm"
      >
        <input
          class="p-2 m-1 w-[95%] leading-5 outline-0 outline-none bg-transparent"
          [(ngModel)]="searchFilter"
          (keydown)="onSearchKeydown($event)"
          [placeholder]="placeholder()"
        />
        @if(searchFilter()){
        <mat-icon
          aria-hidden="false"
          aria-label="clear icon"
          class="hover:cursor-pointer mx-1 w-full"
          fontIcon="close"
          (click)="searchFilter.set('')"
        ></mat-icon>
        }
      </div>
    </div>
    @if(filteredOptions().length === 0){
    <mat-option [disabled]="true">No options available</mat-option>
    } @else{ @if(optionGroup() && searchFilter() === ''){
    <mat-optgroup [label]="optionGroupTitle()">
      @for(opt of optionGroup(); let i = $index ; track i){
      <mat-option [value]="opt">{{ opt }}</mat-option>
      }
    </mat-optgroup>
    } @for(opt of filteredOptions(); let i = $index; track i){
    <mat-option [value]="opt">{{ opt }}</mat-option>
    }}
  </mat-select>
</mat-form-field>
